import React from 'react';
import {Routes, Route, useLocation} from 'react-router-dom';
import {AnimatePresence} from 'framer-motion';
import Home from '../pages/home/Home';
import Page1 from '../pages/page1/Page1';
import PageDigibank from '../pages/page1/Digibank';
import QRPay from '../pages/page1/QRPay';
import GlobalPay from '../pages/page1/GlobalPay';
import Biometric from '../pages/page1/Biometric';
import BiometricTablet from '../pages/page1/BiometricTablet';
import Digisign from '../pages/page1/Digisign';
import DetailDigisign1 from '../pages/page1/Detail-Digisign1';
import DetailDigisign2 from '../pages/page1/Detail-Digisign2';
import { OtherSelectPage } from '../pages/OtherSelect/OtherSelectPage';
const AnimatedRoutes = () => {
  const location = useLocation ();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/page1" element={<Page1 />} />
        <Route path="/page1/digibank" element={<PageDigibank />} />
        <Route path="/page1/qrpay" element={<QRPay />} />
        <Route path="/page1/globalpay" element={<GlobalPay />} />
        <Route path="/page1/biometric" element={<Biometric />} />
        <Route path="/page1/biometric/tablet" element={<BiometricTablet />} />
        <Route path="/page1/digisign" element={<Digisign />} />
        <Route path="/page1/digisign/detail-digisign1" element={<DetailDigisign1 />} />
        <Route path="/page1/digisign/detail-digisign2" element={<DetailDigisign2 />} />
        <Route path="/other" element={<OtherSelectPage />} />

      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
